export function nonBlankString(value?: string) {
  const trimmed = value?.trim();

  return trimmed ? trimmed : undefined;
}
